import { EffectType, ImageEffectType } from '@/typings/customilyElements/imageEffectType';

export enum PresetCategory {
    TOOLS = 'tools',
    STYLE_MODIFIERS = 'style-modifiers',
    CUSTOM_PROMPTS = 'custom-prompts'
}

export enum PresetTag {
    AI = 'AI',
    OPENAI = 'OpenAI',
    OPENROUTER = 'OpenRouter',
    GEMINI = 'Gemini',
    CUTOUT_PRO = 'Cutout Pro',
    REMOVE_BG = 'Remove.BG',
    FACE = 'Face',
    CARTOON = 'Cartoon',
    PENCIL = 'Pencil',
    WATERCOLOR = 'Watercolor',
    ENHANCEMENT = 'Enhancement',
    BACKGROUND = 'Background',
    ARTISTIC = 'Artistic',
    PORTRAIT = 'Portrait',
    STYLE_TRANSFER = 'Style Transfer',
    FREE = 'Free',
    CUSTOMILY = 'Customily',
    BLUR = 'Blur',
    AVATAR = 'Avatar',
    PROMPT = 'Prompt',
    PICWISH = 'PicWish'
}

export interface ImageEffectPreset {
    id: string;
    label: string;
    caption: string;
    thumbnail: string;
    category: PresetCategory;
    tags: PresetTag[];
    effectConfig: ImageEffectType;
    isFree?: boolean;
    order?: number;
}

export interface CombinedPresets {
    label: string;
    thumbnail: string;
    type?: EffectType;
    presets?: ImageEffectPreset[];
    tags?: PresetTag[];
    formData?: ImageEffectType;
    isFree?: boolean;
    caption?: string;
}

export interface PresetCategoryInfo {
    category: PresetCategory;
    label: string;
    description?: string;
    icon?: string;
    order: number;
}

export const SPECIAL_CATEGORY_VALUES = {
    ALL: 'all' as const,
    FREE: 'free' as const
} as const;

export type CategoryValue = PresetCategory | typeof SPECIAL_CATEGORY_VALUES.ALL | typeof SPECIAL_CATEGORY_VALUES.FREE;

export type EffectiveCategory = PresetCategory | typeof SPECIAL_CATEGORY_VALUES.FREE | undefined;

export interface Provider {
    type: EffectType;
    id?: string;
}
